import styles from "./TableBody.module.scss";
import { Checkbox } from "@/frontend/shared/ui/Checkbox";
import { Loader } from "@/frontend/shared/ui/Loader/Loader";
import { buildCells } from "../RowCell/RowCell";
import { getRouteCompanyProfile, getRouteExpertCompanyProfile } from "@/frontend/shared/const/router";
import { Typography } from "@/frontend/shared/ui/Typography";
import clsx from "clsx";
import { useLocation } from "react-router-dom";
import { extractOrganizationId } from "@/frontend/shared/lib/extractOrganizationId/extractOrganizationId";
import { TTableCompany } from "@/frontend/features/Company/model/types/types";
import { ReactNode } from "react";

type TTableBody = {
  selected: number[];
  onChange: (id: number) => void;
  companies: TTableCompany[];
  triggerRefetch: () => void;
  isLoading: boolean;
  isFounder?: boolean;
  actionOptions?: ReactNode[];
};

export function TableBody({ selected, onChange, companies, isLoading, isFounder, actionOptions }: TTableBody) {
  const { pathname } = useLocation();
  const organizationId = extractOrganizationId(pathname) || null;

  switch (true) {
    case isLoading:
      return (
        <div className={styles.loaderContainer}>
          <Loader />
        </div>
      );
    case !!companies.length:
      return (
        <div className={styles.cardContainer}>
          {companies.map((portfolioCompany, index) => {
            return (
              <div
                key={index}
                className={clsx(styles.card, isFounder && styles.isFounderCard)}
                onClick={() =>
                  window.open(
                    organizationId
                      ? getRouteExpertCompanyProfile(organizationId, portfolioCompany.id)
                      : getRouteCompanyProfile(portfolioCompany.id),
                    "_blank"
                  )
                }
              >
                {!isFounder && (
                  <div className={styles.checkboxContainer}>
                    <Checkbox
                      value={selected.includes(portfolioCompany.id)}
                      onChange={() => onChange(portfolioCompany.id)}
                      className={styles.checkbox}
                    />
                  </div>
                )}
                {buildCells(portfolioCompany, isFounder, actionOptions)}
              </div>
            );
          })}
        </div>
      );
    default:
      return (
        <div className={styles.emptyPageContainer}>
          <Typography variant="label-4" color="greyscale600">
            No matching companies found
          </Typography>
        </div>
      );
  }
}
